import {useCallback, useState} from "react";

export const server = {
    Prod: "https://api.notaire-langloys.com",
    PreProd: "https://langloysapi-preprod.azurewebsites.net",
    Test: "http://localhost:8082/http://localhost:8080",
    Dev: "https://langloyscalc.azurewebsites.net"
};
const currentServer = server.Prod;
export const API_BASE_URL = currentServer;

export const ENABLE_REDUX_LOGGER = false;

export function useForceUpdate() {
    const [, setTick] = useState(0);
    const update = useCallback(() => {
        setTick((tick) => tick + 1);
    }, []);
    return update;
}

export default {};

